import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

export const EarnRewardsModal: BaseModalType = ({ close }) => {
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>
        {t(`IB.Tickmill's Loyalty Program offers you more earning opportunities`)}
      </Modal.Header>
      <Modal.Body>
        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>{t('IB.Up to US$ 250,000')}</Modal.Body.Title>
          <Modal.Body.Text>
            {t('IB.Redeem cash rewards on top of your regular IB payouts')}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>
        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>{t('IB.Volume Tiers', { tiers: 13 })}</Modal.Body.Title>
          <Modal.Body.Text>
            {t('IB.Achieve the volume requirement on each tier to redeem the respective prizes', {
              from: '25',
              to: '250,000',
            })}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          link={{
            rel: 'noreferrer',
            target: '_blank',
            href: 'https://www.tickmill.com/partners/ib-loyalty',
          }}
        >
          {t('Loyalty Program.Find out more')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
